import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "As a power user, I want to punch you every time I change a setting",
  "description": "",
  "published": "2012-05-31T00:00:00.000Z",
  "redirect_from": ["/blog/as-a-power-user-i-want-to-punch-you-every-time-i-change-a-setting/swizec/4549"],
  "categories": "Uncategorized",
  "hero": "./img/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/UDE_Screenshot.jpg/300px-UDE_Screenshot.jpg",
        "alt": "English: Screenshot of the Unix Desktop Enviro...",
        "title": "English: Screenshot of the Unix Desktop Enviro..."
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://nick.typepad.com/blog/2012/05/screw-the-power-users.html"
      }}>{`"Screw the power users"`}</a>{` wrote `}<a parentName="p" {...{
        "href": "http://nick.typepad.com/",
        "title": "Nick Bradbury"
      }}>{`Nick Bradbury`}</a>{` about catering both to power users and normal people. The more he improved his product and made it provably better, the more did power users complain about every new release and lost "feature". Loudly.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Sales went up, but positive feedback went down.`}</p>
    </blockquote>
    <p>{`His market targeting was off. But not in the way he thinks it was - the idea that power users need a lot of dials and knobs to play with to make a product juuuuust the way they like ... is wrong.`}</p>
    <p>{`I am a power user. When a piece of software fits me, I `}<em parentName="p">{`use`}</em>{` it.`}</p>
    <p>{`You know those mythical people who use your product every day, several hours a day, tell all their friends and publish blogs on the topic? That's me. I'm that kind of power user.`}</p>
    <p>{`I `}<strong parentName="p">{`hate`}</strong>{` changing settings with a passion.`}</p>
    <p>{`Software is a tool. I'm using it to `}<em parentName="p">{`do`}</em>{` something. I don't want to play around with the tools I use, I want to use them.`}</p>
    <p>{`When your software makes me want to change a setting, I want to punch you in the face. Every time I want to punch you in the face you lose me a little bit as a user. Too many punches and I `}{`_`}{`will `}{`_`}{`leave in search of greener pastures, looking for a tool that fits my use case perfectly.`}</p>
    <p>{`There was a time when most of my days were spent configuring everything I use to make it juuuust right. At 15 I discovered `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Linux",
        "title": "Linux"
      }}>{`Linux`}</a>{`. Linux is awesome because it gives you more than enough rope to hang yourself with.`}</p>
    <p>{`I could spend hours upon hours making sure my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Desktop_environment",
        "title": "Desktop environment"
      }}>{`desktop environment`}</a>{` was using the perfect rendering engine. I would spend hours making sure all the effects were just right and that the toolbar was on the correct side and that my sound was just perfect and that the window decorations were perfect and ...`}</p>
    <p>{`Nowadays I don't even change my wallpaper anymore. It took me two years to change the wallpaper on my iPhone from some random picture my sister set within 2 minutes of `}<em parentName="p">{`"Ooooh, can I look at your new phone?"`}</em></p>
    <p>{`Tools should have defaults that are Good Enough (tm). If the tools you make aren't perfect out of the box, I will simply look for a tool where I'm the target user specifically.`}</p>
    <p>{`Because when a maker is targeting `}<em parentName="p">{`me`}</em>{` as the user, then I can put my trust in them (usually expressed in terms of a credit card transaction). I can be sure a tool won't suddenly stop fulfilling my use case and go a different direction.`}</p>
    <p>{`Being the target user is `}<em parentName="p">{`awesome`}</em>{`.`}</p>
    <p>{`In short, the more configuration you have, the less you know who your target customer is, the less confidence I have in you as a user.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/ba253a711528129db393e75b03d8f94a/91f10/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.78026905829597%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'251\\'%20viewBox=\\'0%200%20400%20251\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%206v6l200-1h201V0H0v6m39%2013c-11%209%201%2026%2014%2019%208-4%208-16%200-21-4-2-10-1-14%202m310%2013l-1%203v3h24l-1-3v-3h-22\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ba253a711528129db393e75b03d8f94a/ca0a1/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.webp 223w", "/static/ba253a711528129db393e75b03d8f94a/75680/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.webp 445w", "/static/ba253a711528129db393e75b03d8f94a/8d1ba/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.webp 890w", "/static/ba253a711528129db393e75b03d8f94a/9012d/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.webp 992w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ba253a711528129db393e75b03d8f94a/e92b6/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png 223w", "/static/ba253a711528129db393e75b03d8f94a/e66bf/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png 445w", "/static/ba253a711528129db393e75b03d8f94a/4ef49/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png 890w", "/static/ba253a711528129db393e75b03d8f94a/91f10/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png 992w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ba253a711528129db393e75b03d8f94a/4ef49/wp-content-uploads-2012-05-CompizConfig-Settings-Manager-Experimental-Tab.png",
                "alt": "Seriously?",
                "title": "Seriously?",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Seriously?`}</figcaption>{`
  `}</figure></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nick.typepad.com/blog/2012/05/screw-the-power-users.html"
        }}>{`Screw the power users`}</a>{` (nick.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rc3.org/2012/05/30/the-debate-over-share-buttons-on-blogs/"
        }}>{`The debate over share buttons on blogs`}</a>{` (rc3.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.macworld.com/article/1166997/sandboxing_will_disadvantage_mac_users_say_developers.html"
        }}>{`Sandboxing will 'disadvantage Mac users,' say developers`}</a>{` (macworld.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.zemanta.com/blog/zemanta-power-user-stuart-aken-2/"
        }}>{`Zemanta Power User - Stuart Aken`}</a>{` (zemanta.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.simplyzesty.com/facebook/are-you-a-facebook-power-user-new-chart-will-tell-you-the-answer/"
        }}>{`Are You A Facebook Power User? New Chart Will Tell You The Answer`}</a>{` (simplyzesty.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.inklingmarkets.com/2012/05/beta-testers-wanted-for-our-new-ios-app.html"
        }}>{`Beta testers wanted for our new iOS app`}</a>{` (inklingmarkets.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=40940726-a223-486f-836f-3fad844b6ac3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      